module.exports = __webpack_public_path__ + "img/visible.0fbe3c30.png";